/* Based on https://gist.github.com/JonCatmull/ecdf9441aaa37336d9ae2c7f9cb7289a  */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filesize'
})
export class FilesizePipe implements PipeTransform {

  private units = [
    'bytes',
    'KB',
    'MB',
    'GB'
  ];

  transform(bytes: number, args?: any): string {

    if (isNaN(parseFloat(String(bytes))) || ! isFinite(bytes)) return "";

    let unit = 0;

    while (bytes >= 1024) {
      bytes /= 1024;
      unit++;
    }

    return `${Math.round(bytes)} ${this.units[unit]}`;
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/filesize.pipe.ts